/**
 * Extend the product-add-to-cart.js of Ajax Cart Pro module to include the form element to data object
 * so that we can use form element in action-mixin.js to provide the required data in order to trigger
 * `ajax:addToCart` event as Magento 2 default logic does
 */
define([
    'jquery',
    'Aheadworks_Ajaxcartpro/js/config',
    'Aheadworks_Ajaxcartpro/js/action',
    'pdpAddToBagModal'
], function($, awAcpConfig, awAcpAction, pdpAddToBagModal) {
    "use strict";

    return function () {
        $.widget('awacp.productAddToCart', $.awacp.action, {
            options: {
                bindSubmit: true,
                redirectToCatalog: false
            },
            _create: function() {
                if (this.options.bindSubmit) {
                    this._super();
                    this._on({
                        'submit': function(event) {
                            event.preventDefault();
                            if (!this.element.valid()) {
                                return;
                            }
                            var data = this.element.serializeArray();
                            data.push({
                                name: 'action_url',
                                value: this.element.attr('action')
                            });
                            data.push({
                                name: 'product_page',
                                value: 1
                            });
                            data.push({
                                name: 'form',
                                value: this.element
                            });
                            this.fire(this.getActionId(), awAcpConfig.acpAddToCartUrl, data, this.options.redirectToCatalog);
                        }
                    });
                }
            },
            getActionId: function() {
                return 'catalog-add-to-cart-' + $.now()
            },

            updateUi: function(content) {
                pdpAddToBagModal.onUiRetrievedForAddToCart(content);
            },
            updateRelated: function(content) {
                pdpAddToBagModal.onUiRetrievedForRelatedProducts(content);
            },
            closeUi: function () {
                pdpAddToBagModal.close();
            }
        });
        return $.awacp.productAddToCart;
    };
});
